<template>
  <div class="try-layout">
    <header class="try-header">
      <div class="try-brand">
        <BrandLogo to="/try" />
        <span class="try-label">TRY</span>
      </div>
      <div class="try-spacer" />
      <div class="try-actions">
        <LocaleSwitcher />
        <ThemeSwitcher />
        <UButton to="/login" color="neutral" variant="outline">{{
          t('app.common.signIn')
        }}</UButton>
      </div>
    </header>
    <main><RouterView /></main>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import BrandLogo from '@/components/BrandLogo.vue'
import LocaleSwitcher from '@/components/LocaleSwitcher.vue'
import ThemeSwitcher from '@/components/ThemeSwitcher.vue'
const { t } = useI18n()
</script>

<style scoped>
.try-layout {
  min-height: 100vh;
  background:
    radial-gradient(
      circle at 90% 8%,
      color-mix(in srgb, var(--fb-coral) 14%, transparent),
      transparent 28%
    ),
    var(--fb-paper);
}
.try-header {
  position: sticky;
  top: 0;
  z-index: 50;
  min-height: 72px;
  padding: 0 max(20px, calc((100vw - 1440px) / 2 + 34px));
  display: flex;
  align-items: center;
  gap: 9px;
  border-bottom: 1px solid color-mix(in srgb, var(--fb-line) 80%, transparent);
  background: color-mix(in srgb, var(--fb-paper) 91%, transparent);
  backdrop-filter: blur(14px);
}
.try-brand,
.try-actions {
  display: flex;
  align-items: center;
  gap: 9px;
}
.try-label {
  padding: 4px 7px;
  border-radius: 6px;
  background: var(--fb-coral-soft);
  color: var(--fb-coral-dark);
  font-size: 9px;
  font-weight: 900;
  letter-spacing: 0.12em;
}
.try-spacer {
  flex: 1;
}
@media (max-width: 650px) {
  .try-header {
    min-height: 104px;
    padding: 9px 10px;
    flex-wrap: wrap;
    align-content: center;
  }
  .try-header :deep(.brand-copy small) {
    display: none;
  }
  .try-brand {
    width: 100%;
  }
  .try-spacer {
    display: none;
  }
  .try-actions {
    width: 100%;
    justify-content: space-between;
    gap: 6px;
  }
  .try-actions > :deep(*) {
    min-width: 0;
  }
}
</style>
